import { useParams } from "react-router-dom";
import { ProgramPhases } from "./ProgramPhases";
import { useProgram } from "@platform/hooks/useProgram";
import { PROGRAM_ROLE_SLUG } from "@core/features/program";

export function ProgramPhasesContainer() {
  const { id: programId } = useParams<{ id: string }>();
  const { program, phases, currentPhase, isLoading } = useProgram();

  const isEnrolledParticipant = program?.user_roles?.includes(
    PROGRAM_ROLE_SLUG.ENROLLED_PARTICIPANT
  );

  if (!isEnrolledParticipant) {
    return null;
  }

  return (
    <ProgramPhases
      currentPhase={currentPhase}
      phases={phases}
      isLoading={isLoading}
      programId={Number(programId)}
    />
  );
}

export default ProgramPhasesContainer;

